import { useAppSelector } from '../hooks/useAppSelector';
import * as referenceSlice from '../data/reference.slice';
import * as userSlice from '../data/user.slice';
import { ApplicationSetting } from '../data/models/application-setting.model';

const DRIVERS_LICENSE_FORMAT_BC = 'ENFORCEDLFORMAT';

export const useEnforceDriversLicenseFormat = (): boolean => {
  const appSettings = useAppSelector(referenceSlice.selectApplicationSettings);
  const userInfo = useAppSelector(userSlice.selectUserInfo);

  const currentAppId = userInfo.applicationGlobalSetting.find(
    (s: ApplicationSetting) =>
      s.applicationSettingBC === DRIVERS_LICENSE_FORMAT_BC,
  )?.applicationTitleID;

  const enforceFormat = appSettings.find(
    (s) =>
      s.applicationSettingBC === DRIVERS_LICENSE_FORMAT_BC &&
      s.applicationTitleID === currentAppId,
  );

  if (!enforceFormat) {
    return false;
  }

  const setting = userInfo.applicationGlobalSetting.find(
    (s: any) =>
      s.applicationGlobalSettingID === enforceFormat.applicationSettingID,
  );

  if (setting) {
    return setting.applicationSettingValue === '1';
  }
  return false;
};
